import { render, staticRenderFns } from "./ClickIcon.vue?vue&type=template&id=749cbed4"
import script from "./ClickIcon.vue?vue&type=script&lang=js"
export * from "./ClickIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports